var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scroller",on:{"click":_vm.scroll}},[_c('Icon',{staticClass:"scroller__icon",class:{ up: _vm.up },attrs:{"name":"arr-scroll","pointer":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }